import React from 'react';
import { useTranslation } from 'react-i18next';
import { OfferState } from '../../../../../../services/offersService';
import useOffer from '../../../../store/offer/useOffer';
import useQuoteSpecs from '../../../../store/offer/useQuoteSpecs';
import OfferLabelValueParameter, {
  SpecFieldChange,
} from '../../offer-actions/parameters/OfferLabelValueParameter';

const VillasureOfferDetails: React.FC = () => {
  const { t } = useTranslation();
  const { offer } = useOffer();
  const { quoteSpecs, setQuoteSpecs } = useQuoteSpecs();

  const insuredValue = offer.details?.calculation_specs?.find(
    ({ specs_field }) => specs_field === 'insured_value',
  );
  const insuredContentValue = offer.details?.calculation_specs?.find(
    ({ specs_field }) => specs_field === 'insured_content_value',
  );
  const insuredValueArt = offer.details?.calculation_specs?.find(
    ({ specs_field }) => specs_field === 'insured_art_value',
  );

  const handleQuoteSpecsChange = ({ field, value }: SpecFieldChange) => {
    setQuoteSpecs({
      ...quoteSpecs,
      [field]: value,
    });
  };

  const commonProps = {
    isMediumFontWeight: true,
    isError: offer.state === OfferState.ERROR,
    onChange: handleQuoteSpecsChange,
  };

  return (
    <>
      <OfferLabelValueParameter
        label={t(
          'SALES-CONVERSATION_OFFERS_SINGLE-OFFER_DETAILS_VILLASURE_REBUILD-VALUE',
        )}
        calculationSpec={insuredValue}
        quoteSpecs={quoteSpecs}
        {...commonProps}
      />
      <OfferLabelValueParameter
        label={t(
          'SALES-CONVERSATION_OFFERS_SINGLE-OFFER_DETAILS_VILLASURE_CONTENT-VALUE',
        )}
        calculationSpec={insuredContentValue}
        quoteSpecs={quoteSpecs}
        {...commonProps}
      />
      <OfferLabelValueParameter
        label={t(
          'SALES-CONVERSATION_OFFERS_SINGLE-OFFER_DETAILS_VILLASURE_ART-VALUE',
        )}
        calculationSpec={insuredValueArt}
        quoteSpecs={quoteSpecs}
        {...commonProps}
      />
    </>
  );
};

export default VillasureOfferDetails;
